import React, { useState } from 'react';
import { Button, Input, Upload, Alert } from 'antd';
import {
  PlusOutlined,
  RollbackOutlined,
  PaperClipOutlined,
} from '@ant-design/icons';
import { validateFileType } from '../../utils/helpers/helpers';

const BetterUpload = ({
  value,
  onChange = (file) => {},
  single = true,
  suffix,
  fileType = 'pdf',
  uploadText = 'Cargar',
  changeText = 'Cambiar',
  existingText = 'Archivo existente',
  asInput = true,
  maxSize = 2,
  ...props
}) => {
  const [errorDetail, setErrorDetail] = useState();

  const validateFile = (file, _fileList) => {
    const isLt2M = file.size / 1024 / 1024 < maxSize;
    if (!isLt2M) {
      setErrorDetail(
        `${file.name} es superior a ${maxSize}MB. El tamaño máximo por archivo es de ${maxSize}MB.`,
      );
      return Upload.LIST_IGNORE;
    }
    if (fileType === 'image' && !file.type.includes('image/')) {
      setErrorDetail(`${file.name} debe ser una imagen.`);
      return Upload.LIST_IGNORE;
    }
    if (fileType === 'pdf' && file.type !== 'application/pdf') {
      setErrorDetail(`${file.name} debe ser un pdf`);
      return Upload.LIST_IGNORE;
    }
    if (fileType === 'custom' && !validateFileType(file, props.accept)) {
      setErrorDetail(`${file.name} debe ser de uno de los tipos permitidos`);
      return Upload.LIST_IGNORE;
    }
    setErrorDetail();
    return false;
  };

  const onSelfChange = (e) => {
    onChange(
      single
        ? e.fileList[0]?.originFileObj
        : e.fileList.map((v) => v.originFileObj),
    );
  };

  return (
    <Upload
      beforeUpload={validateFile}
      listType={asInput ? 'text' : 'picture-card'}
      maxCount={1}
      defaultFileList={
        value
          ? single
            ? [
                {
                  uid: '-1',
                  name: existingText,
                  status: 'done',
                  url: value,
                },
              ]
            : [...value].map((v, i) => ({
                uid: `${-1 * i}`,
                name: existingText,
                status: 'done',
                url: v,
              }))
          : []
      }
      onChange={onSelfChange}
      accept={
        fileType === 'pdf'
          ? 'application/pdf'
          : fileType === 'image'
            ? 'image/*'
            : undefined
      }
      showUploadList={!asInput}
      {...props}
    >
      {asInput ? (
        <Input
          value={value?.name}
          prefix={value?.name && <PaperClipOutlined />}
          suffix={
            <Button htmlType="button">{`${value ? changeText : uploadText} ${
              suffix ? suffix : ''
            }`}</Button>
          }
        />
      ) : (
        <div style={{ zIndex: 1 }}>
          {value ? <RollbackOutlined /> : <PlusOutlined />}
          <div style={{ marginTop: 8, fontWeight: 500 }}>
            {`${value ? changeText : uploadText} ${suffix ? suffix : ''}`}
          </div>
        </div>
      )}
      {errorDetail && (
        <>
          <br></br>
          <Alert showIcon message={errorDetail} type="error" />
          <br></br>
        </>
      )}
    </Upload>
  );
};

export default BetterUpload;
